export const LISTINGS_LIMIT = 50
export const SELECTED_VALUES_SELECTED = 'selectedValues_selected'
export const ATTRIBUTE_DISPLAY_MODE_SELECTED = 'attributeDisplayMode_selected'
export const APPLY_FIELD_SCOPE = 'applyDetails'
export const APPLY_FIELD = { COPY: `${APPLY_FIELD_SCOPE}.copy`, OPERATES: `${APPLY_FIELD_SCOPE}.operates`, OPTIONS: `${APPLY_FIELD_SCOPE}.options` }
export const APPLY_RADIO_TYPE = { ADD: 'add', ERMOVE: 'remove' }
export const APPLY_ADD_OPTIONS_TYPE = { TOP: 'top', BOTTOM: 'bottom' }
export const APPLY_RADIO_TYPE_MAP = {
  [APPLY_RADIO_TYPE.ADD]: '新增',
  [APPLY_RADIO_TYPE.ERMOVE]: '移除'
}
export const APPLY_ADD_OPTIONS_TYPE_MAP = {
  [APPLY_ADD_OPTIONS_TYPE.TOP]: '詳情最上方',
  [APPLY_ADD_OPTIONS_TYPE.BOTTOM]: '詳情最下方'
}
export const APPLY_RADIO_OPTIONS = [
  { label: APPLY_RADIO_TYPE_MAP[APPLY_RADIO_TYPE.ADD], value: APPLY_RADIO_TYPE.ADD },
  { label: APPLY_RADIO_TYPE_MAP[APPLY_RADIO_TYPE.ERMOVE], value: APPLY_RADIO_TYPE.ERMOVE }
]
export const APPLY_ADD_OPTIONS = [
  { label: APPLY_ADD_OPTIONS_TYPE_MAP[APPLY_ADD_OPTIONS_TYPE.TOP], value: APPLY_ADD_OPTIONS_TYPE.TOP },
  { label: APPLY_ADD_OPTIONS_TYPE_MAP[APPLY_ADD_OPTIONS_TYPE.BOTTOM], value: APPLY_ADD_OPTIONS_TYPE.BOTTOM }
]
